import { Button, ButtonGroup, Box } from '@mui/material';
import { ranges, rangesM, rangesS, chartConfigs } from '../utils/constants';

export default function RangeSelector({ 
  chartType, 
  range, 
  onRangeChange, 
  onTradeModeReset 
}) {
  const chartConfig = chartConfigs[chartType];
  
  if (!chartConfig) return null;

  // 1. 先判斷要使用哪一組範圍數據與額外動作
  let currentRanges = [];
  let shouldResetTradeMode = false;

  if (["line", "dualLine", "dualLinePlus", "StackedAreaDualLine"].includes(chartConfig.type)) {
    currentRanges = ranges;
  } 
  else if (["bar", "dualBar", "simpleBar", "StackedAreaLine"].includes(chartConfig.type)) {
    currentRanges = rangesM;
    shouldResetTradeMode = true;
  } 
  else if (["StackedAreaDualBar"].includes(chartConfig.type)) {
    currentRanges = rangesS;
    shouldResetTradeMode = true;
  } 
  else {
    return null;
  }

  // 2. 統一渲染視圖，移除原本的 marginTop 負值
  return (
    <Box 
      sx={{ 
        display: 'flex', 
        justifyContent: 'flex-end',
        mt: 1, // 微微的上方間距
        mb: 2, // 下方留白
        pr: 3  // 右側留一點 padding 讓它不要貼死邊緣
      }}
    >
      <ButtonGroup variant="outlined" size="small">
        {currentRanges.map((r) => (
          <Button
            key={r.key}
            onClick={() => {
              onRangeChange(r.key);
              if (shouldResetTradeMode) {
                onTradeModeReset?.("combined");
              }
            }}
            variant={range === r.key ? "contained" : "outlined"}
          >
            {r.label}
          </Button>
        ))}
      </ButtonGroup>
    </Box>
  );
}